import { useIsMobile, useMainStore } from "_hooks";
import { Layout } from "antd";
import { styled } from "styled-components";
import PropTypes from "prop-types";
import { ThemeModeEnum } from "_constants";

const MainSidebar = ({ children }) => {
  const isMobile = useIsMobile();
  const {
    main: { themeMode },
  } = useMainStore();

  const siderWidth = isMobile ? "100%" : 280;
  return (
    <SiderContainer>
      <Sider
        width={siderWidth}
        theme={
          themeMode === ThemeModeEnum.LIGHT
            ? ThemeModeEnum.LIGHT
            : ThemeModeEnum.DARK
        }
      >
        {children}
      </Sider>
    </SiderContainer>
  );
};

MainSidebar.propTypes = {
  children: PropTypes.node.isRequired,
};

const { Sider } = Layout;

export const SiderContainer = styled.div`
  .ant-layout-sider-light {
    /* background: ${({ theme }) => theme.palette.gray[50]};
    border-right: 1px solid
      ${({ theme }) => theme.palette.grey["Cool Grey"][200]}; */
  }
`;

export default MainSidebar;
